import tagularModule from 'js/store/helpers/tagular'

/**
 * NOTE: This file contains global listeners for navigation, authenticated links,
 *       footer, and sidebar navigation.
 */

const navSearchSubmitBtn = document.body.querySelector(
  '[data-js-selector="nav-search-submit-btn"]'
)

const navSearchForm = document.body.querySelector(
  '[data-js-selector="nav-search-form"]'
)

/**
 * All tracked links should include the `data-tagular-enabled`
 * attribute to track click events.
 *
 * Optional data attributes that will be sent to tagular:
 *   * data-tagular-location
 *   * data-tagular-name
 *   * data-tagular-position
 *   * data-tagular-text
 *
 * NOTE: Check up to 4 parents up the dom tree to see if they are tracked
 *       in a few instances this is still required due to additional elements
 *       clickable elements inside the tracked container.
 */
document.addEventListener('click', e => {
  let parentCount = 0
  let target = e.target

  while (
    parentCount < 4 &&
    target.parentElement &&
    target.dataset.tagularEnabled == null
  ) {
    parentCount += 1
    target = target.parentElement
  }

  const data = target.dataset

  // If we aren't tracking this element exit handler
  if (data.tagularEnabled == null) {
    return
  }

  const tagularData = {
    elementType: target.nodeName.toLowerCase(),
    htmlId: target.id,
    location: data.tagularLocation || 'location missing from element',
    name: data.tagularName || 'name missing from element',
    position: data.tagularPosition || 'position missing from element',
    text: data.tagularText || 'text missing from element'
  }

  tagularModule.elementClicked(
    tagularData,
    `link to ${data.tagularName || data.tagularText}`
  )
})

// Navbar menu item for mortgages only
const navCategoryMortages = document.getElementById('nav-category-mortgages')
navCategoryMortages?.addEventListener('mouseenter', () => {
  // Send tagular event
  window.tagular('beam', 'ElementViewed', {
    '@type': 'redventures.usertracking.v3.ElementViewed',
    webElement: {
      elementType: 'drawer',
      htmlId: 'nav-category-mortgages',
      location: 'navigation',
      name: 'navigation bar',
      position: 'top',
      text: 'navigation bar'
    }
  })
})

// Field Inputted tracking when a user searches using the nav search filter
if (navSearchSubmitBtn && navSearchForm) {
  navSearchSubmitBtn.addEventListener('click', () => {
    const inputValue = navSearchForm.querySelector('input[type=text]').value

    tagularModule.fieldInputted(
      'search bar',
      '[OMITTED]',
      'site search',
      inputValue,
      'site search',
      '[OMITTED]',
      'search',
      'site search'
    )
  })
}
